<template>
    <section class="post-links" :class="{'two-columns' : twoColumns}">
        <h3 class="title-with-icon m-b"><img v-if="icon" :src="require(`@/assets/img/svg/${icon}.svg`)">{{ title }}</h3>
        <ul>
            <li v-for="(item, key) in links" :key="`item-${key}`">
                <a :href="'/blog/' + item.slug" class="post-link">
                    <div class="post-link-date">{{ item.posted_at }}</div>
                    <div class="post-link-text">{{ item.title }}</div>
                </a>
            </li>
        </ul>
    </section>
</template>

<script>
export default {
    props: {
        links: Array,
        icon: {
            type: String,
            default: null,
        },
        title: String,

        twoColumns: Boolean,
    }
}
</script>

<style>

</style>
